import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
// import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress/index";
import StatusButton from "../../../../_metronic/_helpers/StatusButton";
import ConfirmButton from "../modals/ConfirmButton";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import { deepPurple } from "@material-ui/core/colors";
// import { dateConvert } from "../../../../helpers/dateConvert";
import { dateConvertItem } from "../../../../helpers/dateConvertItem";


const headRows = [
  { id: "fileId", numeric: false, disablePadding: true, label: "Image" },

  {
    id: "Partner.Name",
    numeric: false,
    disablePadding: true,
    label: "Partner name",
  },
  {
    id: "CampaignLangs.FirstOrDefault(c => c.LangId == 1)",
    numeric: false,
    disablePadding: true,
    label: " Campaign name",
  },
  {
    id: "discountPercent",
    numeric: false,
    disablePadding: true,
    label: "Discount percent",
  },
  {
    id: "expireDate",
    numeric: false,
    disablePadding: true,
    label: "Expire date",
  },
  { id: "status", numeric: false, disablePadding: true, label: "Status" },

  { id: "tools", numeric: false, disablePadding: true, label: "Actions" },
];

function EnhancedTableHead(props) {
  const {
    // onSelectAllClick,
    order,
    orderBy,
    // numSelected,
    // rowCount,
    onRequestSort,
  } = props;

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? false : false}
            className="px-4 pb-2 pt-2"
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.bool.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    display: "flex",
  },
  title: {
    flex: "0 0 auto",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    onDeleteCampaigns,
  } = props;

  return (
    <Toolbar
      className={clsx(classes.root, classes.toolbar, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton
              className="mr-2 "
              aria-label="Delete"
              onClick={onDeleteCampaigns}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  toolbar: {
    minHeight: theme.spacing(2),
  },
  purpleAvatar: {
    margin: 10,
    marginLeft: 0,
    color: "#fff",
    backgroundColor: deepPurple[500],
  },
  avatar: {
    margin: 10,
    marginLeft: 0,
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#63C059",
  },
}));

export default function EnhancedTable(props) {
  const {
    setSortField,
    setOrderByTable,
    sortField,
    orderBy,
    setOpenCreate,
    isLoaded,
    error,
    rows,
    onUpdateUserStatus,
    onConfirmStatus,
    updateSkip,
    updateTake,
    count,
    setDeleteCampaignsID,
    deleteCampaignsIds,
    onDeleteCampaigns,
    onCampaignsExport,
  } = props;
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  function handleRequestSort(property) {
    const isDesc = sortField === property && !orderBy;

    setOrderByTable(isDesc);
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);

      setDeleteCampaignsID(newSelecteds);
      return;
    }

    setDeleteCampaignsID([]);
  }


  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage * rowsPerPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }


  return (
    <div className="col-12">
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {isLoaded && !rows.length && (
            <div className={classes.progresRoot}>
              <CircularProgress className={classes.progress} />
            </div>
          )}
          <EnhancedTableToolbar
            numSelected={deleteCampaignsIds.length}
            setOpenCreate={setOpenCreate}
            onDeleteCampaigns={onDeleteCampaigns}
            onCampaignsExport={onCampaignsExport}
          />
          <div className={classes.tableWrapper}>
            {rows.length ? (
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  numSelected={deleteCampaignsIds.length}
                  order={orderBy}
                  orderBy={sortField}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                      >
                  
                        <TableCell
                          component="th"
                          // id={labelId}
                          scope="row"
                          padding="none"
                          className="pr-4 px-4"
                        >
                          <Grid>
                            <Avatar
                              src={`${
                                row.filePath
                                  ? `https://cdn.deyerlisen.az/${row.filePath}`
                                  : "/media/logos/default.png"
                              }`}
                              className={classes.avatar}
                            />
                          </Grid>
                        </TableCell>
                        <TableCell padding="none" className="pr-4 px-4">
                          {row.partnerName}
                        </TableCell>
                        <TableCell padding="none" className="pr-4 px-4 ">
                          {row.nameAz}
                        </TableCell>
                        <TableCell padding="none" className="pr-4 px-4 ">
                          {row.discountPercent} 
                        </TableCell>
                        <TableCell padding="none" className="pr-4 px-4 ">
                          {dateConvertItem(row.expireDate)}
                        </TableCell>

                        <TableCell padding="none" className="pr-4 px-4 ">
                        <StatusButton
                              id={row.id}
                              isActive={row.isActive}
                              onUpdateUserStatus={onUpdateUserStatus}
                            />
                      </TableCell>
                        <TableCell padding="none" className="pr-4 px-4 ">
                        <ConfirmButton
                              id={row.id}
                              onConfirmStatus={onConfirmStatus}
                            />
                      </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : !rows.length && !isLoaded && !error ? (
              // <AlertComponent variant="info" message="No information found" />
              <div className="noInfo"><img src="./media/error/search2.png" alt="information"/>
              <h4>No information found</h4></div>
            ) : (
              !isLoaded &&
              error && (
                // <AlertComponent
                //   variant="danger"
                //   message="We've lost the connection"
                // />
                <div className="noInfo"><img src="./media/error/connection.png" className="info-img" alt="connection" />
                <h4>We've lost the connection</h4></div>
              )
            )}
          </div>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
      </div>
    </div>
  );
}
